<template>
  <div
    class="d-inline-flex align-center shrink padding-a-2 border-1 border-solid border-border-gray border-radius-regular font-14 "
  >
    <CUIcon color="primary" view-box="0 0 24 24" class="margin-r-1">
      info
    </CUIcon>
    {{ $t('reservationDetail.contactInformation.WANT_SMS_UPDATES') }}

    <a class="margin-x-1 font-medium" @click="open">
      {{ $t('reservationDetail.contactInformation.VERIFY_YOUR_NUMBER') }}
    </a>
    <ReservationDetailVerifySMS
      v-if="showSMSConfirmation"
      confirmation-header="Confirm Your Phone Number"
      confirmation-subheader="Please confirm or update your cell phone number."
      :customer="customer"
      skippable
      closeable
      @skip="close"
      @confirm="handleConfirmed"
    />
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ReservationDetailVerifySMS from '@/components/ReservationDetailVerifySMS.vue'
import auth from '../store/modules/auth'
import { Customer } from '../models/dto'

@Component({ components: { ReservationDetailVerifySMS } })
export default class ReservationDetailContactInfomationVerifySMS extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  readonly isVerifyPhoneModalOpen: boolean

  showSMSConfirmation = false

  @Watch('isVerifyPhoneModalOpen')
  isVerifyPhoneModalOpenChanged(val: boolean): any {
    this.showSMSConfirmation = this.isVerifyPhoneModalOpen && !auth.customer?.smsConfirmed
  }

  get customer(): Customer {
    return auth.customer
  }

  handleConfirmed(): void {
    this.close()
  }

  mounted(): void {
    this.showSMSConfirmation = this.isVerifyPhoneModalOpen && !auth.customer?.smsConfirmed
  }

  open(): void {
    this.showSMSConfirmation = true
  }

  close(): void {
    this.showSMSConfirmation = false
  }
}
</script>
